<template>
  <router-view #="{ Component }">
    <a-config-provider
      :theme="{
        token: {
          colorPrimary: store.themeColor,
        },
      }"
    >
      <component :is="Component" />
    </a-config-provider>
  </router-view>

  <!--  水印组件-->
  <Watermark :watermarkText="userId" />
</template>
<script setup>
import { userStore } from '@/store/user';
import Watermark from './components/watermark/Watermark.vue';
import { onMounted, ref, watch } from 'vue';
import * as loginApi from '@/api/login.js';
import { decrypt, myDecryptBySM2 } from '@/utils/cryptoConfig';
const store = userStore();

const userId = ref('');

watch(
  () => store.userInfo,
  newVal => {
    console.log(newVal);
    const name = newVal.realname?.encryptedValue || newVal.username?.encryptedValue;
    userId.value = myDecryptBySM2(name) + ' ' + newVal.id;
    // loginApi.getUserInfoNoMask().then(res => {
    //   userId.value = decrypt(res.realname) + ' ' + res.id;
    // });
  }
);

onMounted(() => {
  // if (basicStorage.getItem('token')) {
  //   console.log(basicStorage.getItem('token'));
  //   loginApi.getUserInfo().then(res => {
  //     userId.value = res.realname + '' + res.id;
  //   });
  // }
});
</script>
